<template>
  <div class="row" v-if="contribution">
    <div class="col-12">
      <form :name="`contributionForm-${index}`" method="post" @submit.prevent="save">
        <fieldset :disabled="loading">
          <div class="form-group">
            <label :for="`contributionName-${index}`">Namn</label>

            <div class="input-group">
              <input type="text" :name="`contributionName-${index}`" :id="`contributionName-${index}`" v-model="contribution.name" class="form-control">
              <div class="input-group-append">
                <button type="submit" class="btn btn-success" title="Spara namn">Spara</button>
                <button type="button" class="btn btn-danger" title="Ta bort bidrag" @click="removeContribution">X</button>
                <button type="button" class="btn btn-secondary" title="Lägg till / ta bort poäng" @click="addPoints">+/-</button>
              </div>
            </div>

            <div class="form-text text-muted">Poäng: {{ sum(contribution.points) }}</div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  import sum from "lodash/sum"

  export default {
    name: "admin-contribution",
    props: {
      data: { type: Object, required: true, },
      index: { type: Number, required: true, },
    },
    data() {
      return {
        sum: sum,
        loading: false,
        contribution: null,
      }
    },
    methods: {
      async save() {
        this.loading = true

        console.log(this.contribution.name)

        let contributionRef = await firebase.firestore().collection(`contributions`).doc(this.data.id)
        await contributionRef.update({
          name: this.contribution.name,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }) 

        this.loading = false
      },
      async removeContribution() {
        let remove = confirm("Är du helt säker på detta?")

        if (remove) {
          this.loading = true
          await firebase.firestore().collection(`contributions`).doc(this.data.id).delete()
          this.loading = false
        }
      },
      async addPoints() {
        this.loading = true

        let points = prompt("Poäng (Använd - för att ta bort och justera poäng)", 0)

        if (points != null) {
          let numeric = parseInt(points)
          if (isNaN(numeric)) {
            alert("Måste vara numeriskt ju ...")
          } else {
            if (numeric === 0) {
              alert("Känns onödigt att lägga till 0 ju ...")
            } else {
              try {
                let points = this.data.points
                points.push(numeric)
                let contributionRef = await firebase.firestore().collection(`contributions`).doc(this.data.id)
                await contributionRef.update({
                  points: points,
                  updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
                }) 
              } catch {
                this.loading = false
              }
            }
          }
        }

        this.loading = false
      },
    },
    mounted() {
      this.contribution = this.data
    },
    watch: {
      "data": function(data) {
        if (data) {
          this.contribution = data
        }
      }
    }
  }
</script>